import Types from './Types';


export const getAllQuestionsBankRequest = (id) => ({
    type: Types.GET_QUESTIONS_BANK_REQUEST,
    payload: id
});

export const getAllQuestionsBankSuccess = (data) => ({
    type: Types.GET_QUESTIONS_BANK_SUCCESS,
    payload: data
});

export const getAllQuestionsBankFail = () => ({
    type: Types.GET_QUESTIONS_BANK_FAIL
});


export const editQuestionBankRequest = (formData) => ({
    type: Types.EDIT_QUESTION_BANK_REQUEST,
    payload: formData,
});

export const editQuestionBankSuccess = (data) => ({
    type: Types.EDIT_QUESTION_BANK_SUCCESS,
    payload: data
});

export const editQuestionBankFail = () => ({
    type: Types.EDIT_QUESTION_BANK_FAIL
});

//LOADING
export const addQuestionBankLoading = (isLoading) => ({
    type: Types.ADD_QUESTION_BANK_LOADING,
    payload: isLoading
});

// Create QuestionBank
export const createQuestionBankRequest = (formData, action) => ({
    type: Types.CREATE_QUESTION_BANK_REQUEST,
    payload: formData,
    action: action
});

export const createQuestionBankSuccess = ({ data }) => ({
    type: Types.CREATE_QUESTION_BANK_SUCCESS,
    payload: {
        data
    }
});

export const createQuestionBankFail = () => ({
    type: Types.CREATE_QUESTION_BANK_FAIL
});

export const deleteQuestionBankRequest = (id) => ({
    type: Types.DELETE_QUESTION_BANK_REQUEST,
    payload: id
});

export const deleteQuestionBankSuccess = (id) => ({
    type: Types.DELETE_QUESTION_BANK_SUCCESS,
    payload: id
});

export const deleteQuestionBankFail = () => ({
    type: Types.DELETE_QUESTION_BANK_FAIL
});

export const hardDeleteQuestionBankRequest = (id) => ({
    type: Types.HARD_DELETE_QUESTION_BANK_REQUEST,
    payload: id
});

export const hardDeleteQuestionBankSuccess = (id) => ({
    type: Types.HARD_DELETE_QUESTION_BANK_SUCCESS,
    payload: id
});

export const hardDeleteQuestionBankFail = () => ({
    type: Types.HARD_DELETE_QUESTION_BANK_FAIL
});

export const bookmarkQuestionBankRequest = (id) => ({
    type: Types.BOOKMARK_QUESTION_BANK_REQUEST,
    payload: id
});

export const bookmarkQuestionBankSuccess = (id) => ({
    type: Types.BOOKMARK_QUESTION_BANK_SUCCESS,
    payload: id
});

export const bookmarkQuestionBankFail = () => ({
    type: Types.BOOKMARK_QUESTION_BANK_FAIL
});

export const suspendQuestionBankLoading = (isLoading) => ({
    type: Types.SUSPEND_QUESTION_BANK_LOADING,
    payload: isLoading
});


export const bookmarkQuestionBankLoading = (isLoading) => ({
    type: Types.BOOKMARK_QUESTION_BANK_LOADING,
    payload: isLoading
});

export const getTopMissedQuestionsForAdminRequest = () => ({
    type: Types.GET_TOP_MISSED_QUESTIONS_FOR_ADMIN_REQUEST
});

export const getTopMissedQuestionsForAdminSuccess = (data) => ({
    type: Types.GET_TOP_MISSED_QUESTIONS_FOR_ADMIN_SUCCESS,
    payload: data
});

export const getTopMissedQuestionsForAdminFail = () => ({
    type: Types.GET_TOP_MISSED_QUESTIONS_FOR_ADMIN_FAIL
});

export const updateQuestionTagsRequest = (id, tags) => ({
    type: Types.UPDATE_QUESTION_TAGS_REQUEST,
    payload: { id, tags }
});

export const updateQuestionTagsSuccess = (data) => ({
    type: Types.UPDATE_QUESTION_TAGS_SUCCESS,
    payload: data
});

export const updateQuestionTagsFail = () => ({
    type: Types.UPDATE_QUESTION_TAGS_FAIL
});

export const updateQuestionTagsLoading = (isLoading) => ({
    type: Types.UPDATE_QUESTION_TAGS_LOADING,
    payload: isLoading
});

export const toggleMissedEnabledRequest = (id) => ({
    type: Types.TOGGLE_MISSED_ENABLED_REQUEST,
    payload: id
});

export const toggleMissedEnabledSuccess = (data) => ({
    type: Types.TOGGLE_MISSED_ENABLED_SUCCESS,
    payload: data
});

export const toggleMissedEnabledFail = () => ({
    type: Types.TOGGLE_MISSED_ENABLED_FAIL
});

export const toggleMissedEnabledLoading = (id) => ({
    type: Types.TOGGLE_MISSED_ENABLED_LOADING,
    payload: id
});

export const splitPdfQuestionsLoading = (isLoading, target = "questions") => ({
    type: Types.SPLIT_PDF_LOADING,
    payload: isLoading,
    target
});

export const splitPdfQuestionsRequest = (formData, target = "questions") => ({
    type: Types.SPLIT_PDF_QUESTIONS_REQUEST,
    payload: formData,
    target
});

export const splitPdfQuestionsSuccess = (data, target = "questions") => ({
    type: Types.SPLIT_PDF_QUESTIONS_SUCCESS,
    payload: data,
    target
});

export const splitPdfQuestionsFail = () => ({
    type: Types.SPLIT_PDF_QUESTIONS_FAIL
});

export const bulkCreateQuestionBankRequest = (payload, action) => ({
    type: Types.BULK_CREATE_QUESTION_BANK_REQUEST,
    payload,
    action
});

export const bulkCreateQuestionBankSuccess = (data) => ({
    type: Types.BULK_CREATE_QUESTION_BANK_SUCCESS,
    payload: data
});

export const bulkCreateQuestionBankFail = () => ({
    type: Types.BULK_CREATE_QUESTION_BANK_FAIL
});